import { commonActions } from '../../actions/commonActions';
import { connect } from 'react-redux';
import Register from '../../components/login/Register';


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => 
        dispatch(commonActions.pagePreLoaded(view))
  });


export default connect(null, mapDispatchToProps)(Register);
